import { fireStore } from '../firebase';

export const getDocs = async () => {
  let docRef = fireStore.collection('analysisLevelGuide');

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}
